import { RouteConfig } from 'vue-router';
const ExportFolder = () => import('./views/export-folder.vue');
const routers: RouteConfig[] = [
    {
        path: 'export-folder',
        name: 'export-folder',
        component: ExportFolder
    },
];
export default routers;

